import { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import SignupAIPixel from './pages/SignupAIPixel.jsx';
import DeployFreePlan from './pages/_Signup.jsx';
import AccountRecovery from './pages/AccountRecovery.jsx';
import OnboardingSignup from './pages/OnboardingSignup.jsx';
import OnboardingEmailVerification from './pages/OnboardingEmailVerification.jsx';
import OnboardingWorkspaceSetup from './pages/OnboardingWorkspaceSetup.jsx';
import OnboardingTrialStarted from './pages/OnboardingTrialStarted.jsx';
import { trackCustomerIoPage } from './utils/customerio.js';

/**
 * GTM loads once with the initial URL; React Router navigations do not reload the
 * page. Push a custom event so GTM can fire tags (e.g. GA4 page_view) on each route.
 */
function GtmSpaVirtualPageView() {
  const location = useLocation();
  const isFirstNavigation = useRef(true);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;
    window.dataLayer = window.dataLayer || [];
    if (isFirstNavigation.current) {
      isFirstNavigation.current = false;
      trackCustomerIoPage(pagePath);
      return;
    }
    window.dataLayer.push({
      event: 'spa_virtual_page_view',
      page_path: pagePath,
      page_location: window.location.href,
      page_title: document.title,
    });
    trackCustomerIoPage(pagePath);
  }, [location]);

  return null;
}

function AppRoutes() {
  return (
    <>
      <GtmSpaVirtualPageView />
      <Routes>
        <Route path="/signup" element={<OnboardingSignup />} />
        <Route path="/verify-email" element={<OnboardingEmailVerification />} />
        <Route
          path="/workspace-setup"
          element={<OnboardingWorkspaceSetup />}
        />
        <Route path="/trial-started" element={<OnboardingTrialStarted />} />
        <Route path="/account-recovery" element={<AccountRecovery />} />
        <Route path="/aipixel-email" element={<SignupAIPixel />} />
        <Route path="/aipixel" element={<DeployFreePlan />} />
        <Route path="*" element={<OnboardingSignup />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
